import { render, staticRenderFns } from "./UbBadge.vue?vue&type=template&id=d3514050&"
import script from "./UbBadge.vue?vue&type=script&lang=js&"
export * from "./UbBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports